import { createSlice } from "@reduxjs/toolkit";
import uuidv4 from "uuid/v4";
import { enableMapSet } from 'immer';
import { compare, findChatType } from "../../Helpers/Utility";
enableMapSet();

const getDisplayNamefromRoster = (roster = []) => {
    const getAllNames = roster.map(profile => {
      const jid = (profile.username) ? profile.username : profile.userId;
      const displayData = {"displayName": profile.nickName,"chatType": findChatType(profile.userJid),"initialName": profile.nickName}
      const newProfile = { ...profile, ...displayData}
      return [jid, newProfile]
    })
    return new Map(getAllNames)
  }

  const addNewRoster = (state, newData = {}) => {
    let {
      data = [], rosterNames
    } = state;
    if (newData.userId && !rosterNames.has(newData.userId)) {
      data = [...data, newData];
      rosterNames = getDisplayNamefromRoster(data);
    }
    return {
      rosterNames,
      data
    }
  }
  
  const upsertRoster = (rosterDataUpsertFunc = [], newData = [], pageNumber = 1) => {

    if (pageNumber === 1) {
      for (let roster in rosterDataUpsertFunc) {
        if (rosterDataUpsertFunc[roster].isFriend) {
          rosterDataUpsertFunc[roster].isFriend = false;
        }
      }
    }
  
    for (let user in newData) {
      let key = userExists(rosterDataUpsertFunc, newData[user].userId)
      let keyValue = key === undefined ? -1 : key
      if (keyValue > -1) {
        rosterDataUpsertFunc[keyValue] = newData[user];
      } else {
        rosterDataUpsertFunc.push(newData[user]);
      }
    }
   
    // // let contacts = rosterDataUpsertFunc.sort(compare);
    return [...rosterDataUpsertFunc.sort(compare)];
  }

  const userExists = (rosterDataExists, userId) => {
    for (let user in rosterDataExists) {
      if (rosterDataExists[user].userId === userId) {
        return user;
      }
    }
    // // return false;
  }
  
const initialState = {

}

const updateRoster = (rosterDatas = [], newData = {}) => {
  return rosterDatas.map(profile => {
    if (newData.userId === profile.userId) {
      return {
        ...profile,
        ...newData
      }
    }
    return profile
  })
}

const rosterData = createSlice({
    name:'rosterData',
    initialState,
    reducers:{
        addRosterData: (_state,payload)=>{
               return {
                "id" : uuidv4(),
                "data": payload.payload,
                "rosterNames": getDisplayNamefromRoster(payload.payload),
                "isFetchingUserList":false,
                "initialRosterFetched":false
               }
        },
        addNewRosterAction:(_state,payload)=>{
          const rosters = addNewRoster(_state,payload.payload)
            return {
              ..._state,
                "id":uuidv4(),
              ...rosters
            }
        },
        fetchingUserList:(_state,payload)=>{
          return{
            ..._state,
            isFetchingUserList: payload.payload
          }
        },
        rosterDataUpsert:(_state,payload)=>{
          const pageNumber = payload.payload.pageNumber;
          const roster = upsertRoster(JSON.parse(JSON.stringify(_state)).data,payload.payload.data, pageNumber);
          return {
            ...payload.payload,
              data: roster,
              rosterNames: getDisplayNamefromRoster(roster),
              isFetchingUserList: false,
              initialRosterFetched: true
          }  
        },
        rosterUpdate: (_state,payload)=>{
          // const {id, data} = payload.payload
          const rosterDetails = updateRoster(JSON.parse(JSON.stringify(_state)).data, payload.payload)
        return {
          ..._state,
          data: rosterDetails,
          rosterNames: getDisplayNamefromRoster(rosterDetails)
        }
      },
      setInitialRoster: (_state)=>{
      return {
          ..._state,
          data: [],
      } 
    }}
});

export default rosterData.reducer
export const addRosterData = rosterData.actions.addRosterData  
export const addNewRosterAction = rosterData.actions.addNewRosterAction  
export const fetchingUserList = rosterData.actions.fetchingUserList  
export const rosterDataUpsert = rosterData.actions.rosterDataUpsert  
export const rosterUpdate = rosterData.actions.rosterUpdate
export const setInitialRoster = rosterData.actions.setInitialRoster